
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insights/how-great-lawyers-think",
      function () {
        return require("private-next-pages/insights/how-great-lawyers-think.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insights/how-great-lawyers-think"])
      });
    }
  